<ng-select
  *ngIf="companyService.selectedCompany"
  [items]="companyService.selectedCompany?.departments"
  [placeholder]="localizationConstants.DEPARTMENT_SELECT_ALL | translate"
  [clearable]="false"
  [searchable]="false"
  [virtualScroll]="true"
  class="dept header"
  [ngModel]="companyService.selectedCompany.department"
  (ngModelChange)="onDepartmentSelectionChange($event)"
  required>
  <ng-template
    ng-label-tmp
    let-item="item"
    let-clear="clear">
    <span
      *ngIf="item.departmentFilterType === departmentFilterType.NoDepartment"
      class="flex between gap-lg">
      <span class="ng-value-label">{{
        localizationConstants.DEPARTMENT_NO_DEPARTMENT_SELECTION | translate
      }}</span>
      <mat-icon svgIcon="chevronDown"></mat-icon
    ></span>
    <span
      *ngIf="item.departmentFilterType === departmentFilterType.Department"
      class="flex between gap-lg"
      ><span class="ng-value-label">{{
        item.fullName ? item.fullName + ", " + item.name : item.name
      }}</span>
      <mat-icon svgIcon="chevronDown"></mat-icon>
    </span>
    <span
      *ngIf="item.departmentFilterType === departmentFilterType.AllDepartments"
      class="flex between gap-lg"
      ><span class="ng-value-label">{{
        localizationConstants.DEPARTMENT_SELECT_ALL | translate
      }}</span>
      <mat-icon svgIcon="chevronDown"></mat-icon>
    </span>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm">
    <span
      *ngIf="item.departmentFilterType === departmentFilterType.NoDepartment"
      style="width: 100%"
      class="ng-value-label"
      >{{ localizationConstants.DEPARTMENT_NO_DEPARTMENT_SELECTION | translate }}</span
    >
    <span
      *ngIf="item.departmentFilterType === departmentFilterType.Department"
      style="width: 100%"
      class="ng-value-label"
      >{{ item.fullName ? item.fullName + ", " + item.name : item.name }}</span
    >
    <span
      *ngIf="item.departmentFilterType === departmentFilterType.AllDepartments"
      style="width: 100%"
      class="ng-value-label"
      >{{ localizationConstants.DEPARTMENT_SELECT_ALL | translate }}</span
    >
  </ng-template>
</ng-select>
